import styled from "styled-components";

export default styled.h2`
    color: white;
    font-family: 'Inter', sans-serif;
    font-size: 22pt;
    text-align: center;
`;